import { createStore, applyMiddleware, compose } from 'redux';
import { reduxBatch } from '@manaflair/redux-batch';
import { initSagas } from 'initSagas';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import { combinedReducers } from './combinedReducers';
import { revueHubStartListener } from './signalR';
import { loadState } from './localStorage';
import { revueHubConnection } from 'signalR';

export let store;

export const configureStore = (history, initialState) => {

  const actionSanitizer = action => {
    const { payload, type } = action;
    switch (type) {
      default:
        return { ...action, payload };
    }
  };

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        actionSanitizer,
      })
    : compose;


  const sagaMiddleware = createSagaMiddleware();
  const middlewares = [sagaMiddleware, routerMiddleware(history)];  //, logger];
  const persistedState = loadState(initialState);
  store = createStore(combinedReducers(history), persistedState, composeEnhancers(reduxBatch, applyMiddleware(...middlewares), reduxBatch));
  initSagas(sagaMiddleware);
  revueHubConnection.create(store);
  revueHubStartListener(store, () => console.log('revueHub started...'));
  return store;
};